import { useState } from 'react';
import Navbar from '../components/Navbar';
import { PlusIcon, UserPlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';
import { getToken } from '../utils/auth';
import ListUsers from '../components/panel/ListUsers';
import PublisherAssignment from '../components/panel/PublisherAssignment';
import RegionExclusion from '../components/panel/RegionExclusion';
import ChangePassword from '../components/panel/ChangePassword';

const { VITE_API_SERVICE } = import.meta.env;

export default function AdminPanel() {
  const [newUser, setNewUser] = useState({
    email: '',
    password: '',
    isAdmin: false
  });
  const token = getToken();

  async function handleCreateUser(e) {
    e.preventDefault();
    try {
      const response = await fetch(`${VITE_API_SERVICE}/v1/users/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          email: newUser.email,
          password: newUser.password,
          role: newUser.isAdmin ? 'admin' : 'user'
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create user');
      }

      setNewUser({ email: '', password: '', isAdmin: false });
      document.getElementById('add_user_modal').close();
      window.location.reload();
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : 'Failed to create user'
      );
    }
  }

  return (
    <div className="min-h-screen bg-base-100">
      <div className="container mx-auto">
        <Navbar />
        <main className="flex-1 p-4 pb-32 overflow-x-auto min-w-0">
          {/* Header with Add User Button */}
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold">Admin Panel</h1>
            <button
              className="btn btn-ghost"
              onClick={() =>
                document.getElementById('add_user_modal').showModal()
              }
            >
              <UserPlusIcon className="h-5 w-5" />
              Add User
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left column - Users List */}
            <div className="md:row-span-2">
              <ListUsers />
            </div>

            {/* Right column - Publisher Assignment, Region Exclusion, and Change Password stacked */}
            <div className="space-y-6">
              <PublisherAssignment />
              <RegionExclusion />
              <ChangePassword />
            </div>
          </div>

          {/* Add User Modal */}
          <dialog id="add_user_modal" className="modal">
            <div className="modal-box bg-white">
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-lg">Add New User</h3>
                <button
                  className="btn btn-ghost btn-sm btn-circle"
                  onClick={() =>
                    document.getElementById('add_user_modal').close()
                  }
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>
              </div>
              <form onSubmit={handleCreateUser}>
                <div className="form-control mb-2">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    type="email"
                    placeholder="john.doe@example.com"
                    className="input input-bordered w-full"
                    value={newUser.email}
                    onChange={(e) =>
                      setNewUser({ ...newUser, email: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="form-control mb-2">
                  <label className="label">
                    <span className="label-text">Password</span>
                  </label>
                  <input
                    type="password"
                    placeholder="••••••••"
                    className="input input-bordered w-full"
                    value={newUser.password}
                    onChange={(e) =>
                      setNewUser({ ...newUser, password: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="form-control mb-4">
                  <label className="label">
                    <span className="label-text">Admin User</span>
                  </label>
                  <input
                    type="checkbox"
                    className="toggle toggle-sm"
                    checked={newUser.isAdmin}
                    onChange={(e) =>
                      setNewUser({
                        ...newUser,
                        isAdmin: e.target.checked
                      })
                    }
                  />
                </div>

                <div className="modal-action">
                  <button type="submit" className="btn btn-ghost">
                    Create User
                    <PlusIcon className="h-5 w-5" />
                  </button>
                </div>
              </form>
            </div>
            <form method="dialog" className="modal-backdrop">
              <button>close</button>
            </form>
          </dialog>
        </main>
      </div>
    </div>
  );
}
